module.exports = __webpack_public_path__ + "img/ic_logo_penguin@2x.208eb9aa.png";